import { render, staticRenderFns } from "./SimpleVerticalIndicator.vue?vue&type=template&id=15ecc45c&scoped=true"
import script from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleVerticalIndicator.vue?vue&type=style&index=0&id=15ecc45c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ecc45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ecc45c')) {
      api.createRecord('15ecc45c', component.options)
    } else {
      api.reload('15ecc45c', component.options)
    }
    module.hot.accept("./SimpleVerticalIndicator.vue?vue&type=template&id=15ecc45c&scoped=true", function () {
      api.rerender('15ecc45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue"
export default component.exports